export class ExpenseType {
  id: number = null;
  code: string = null;
  name: string = null;
  attachmentIsRequired: boolean = null;
  IsActive: boolean = null;
}
